<template>
  <div
    class="vote-item-tag overflow-hidden bg-highlight text-interaction-dark text-chplus-s rounded-lg"
    :class="{
      'items-center flex flex-col w-24 h-20 p-2': !inline,
      'px-2': inline
    }"
  >
    <vote-topic-icon
      :class="{ 'mr-1': inline, 'w-full flex-grow': !inline }"
      :topic="topic"
    />
    <span class="truncate w-full">{{ topic.name }}</span>
  </div>
</template>
<script>
import VoteTopicIcon from "./VoteTopicIcon.vue";

export default {
  name: "VoteItemTag",
  components: {
    VoteTopicIcon
  },
  props: {
    topic: {
      type: Object,
      required: true
    },
    inline: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.vote-item-tag {
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
